import PrimaryButton from '@/components/ui/buttons/PrimaryButton';
import { SectionHeader } from '@/components/ui/layout/SectionHeader';
import { getActiveLocale } from '@/utils/active-locale';
import { useRouter } from 'next/navigation';
import React from 'react';

interface ContentOverlayProps {
  disableParallax: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dictionary: any;
}

export const ContentOverlay: React.FC<ContentOverlayProps> = ({ disableParallax, dictionary }) => {
  const activeLocale = getActiveLocale();
  const router = useRouter();
  const coffeeHandler = () => {
    router.push('/' + activeLocale + '/contact');
  };

  if (disableParallax) {
    // In grid view: gewoon in de normale flow, gecentreerd
    return (
      <article className='w-full max-w-[400px] text-left p-4'>
        <div className='flex flex-col gap-4 mb-6 items-start'>
          <SectionHeader content={dictionary.home.watch_inside} textColor='text-dark-900' />
          <p className='text-base leading-6 text-grey-700 max-sm:text-sm max-sm:leading-5'>{dictionary.home.brainstorm}</p>
        </div>
        <PrimaryButton onClick={coffeeHandler} label='Koffie' bgColor='bg-yellow-600' hoverBgColor='hover:bg-yellow-500' />
      </article>
    );
  }

  // In parallax view: absoluut gepositioneerd als overlay
  return (
    <article className='absolute left-[554px] max-w-[284px] top-[127px] max-lg:relative max-lg:top-auto max-lg:left-auto max-lg:mt-10 max-lg:max-w-full max-lg:text-center'>
      <div className='flex flex-col gap-4 mb-6'>
        <SectionHeader content={dictionary.home.watch_inside} textColor='text-dark-900' />
        <p className='text-base leading-6 text-grey-700 max-sm:text-sm max-sm:leading-5'>{dictionary.home.brainstorm}</p>
      </div>
      <PrimaryButton onClick={coffeeHandler} label={dictionary.home.coffee} bgColor='bg-yellow-600' hoverBgColor='hover:bg-yellow-500' />
    </article>
  );
};
